import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import { SelectArrayInputProps, usePermissions } from 'react-admin';
import { PermissionData } from '../entities/permission.entity';
import { SelectListAgencyInput } from './common';

const XFilterAgency = (props: SelectArrayInputProps & { multiple?: boolean }) => {
  const { multiple = true } = props;
  const { permissions } = usePermissions<PermissionData>();
  const checkPermission = keyBy(permissions?.permissions, 'resource');
  const isAdmin = !isEmpty(checkPermission['*']?.action);

  if (!isAdmin) {
    return <></>;
  }

  return <SelectListAgencyInput {...props} multiple={multiple} />;
};

export default XFilterAgency;
